import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { APP_BASE_HREF, PathLocationStrategy, PlatformLocation } from '@angular/common';

export const IS_PD_ALIAS = new InjectionToken<boolean>('isPdAlias');
export const PD_ALIAS_CANONICAL_LOCALE = new InjectionToken<string>('pdAliasCanonicalLocale');

@Injectable()
export class PdAliasLocationStrategy extends PathLocationStrategy {
  private readonly isPdAlias: boolean;
  private readonly canonicalPrefix: string;

  constructor(
    platformLocation: PlatformLocation,
    @Optional() @Inject(APP_BASE_HREF) baseHref?: string,
    @Optional() @Inject(IS_PD_ALIAS) isPdAlias?: boolean,
    @Optional() @Inject(PD_ALIAS_CANONICAL_LOCALE) canonicalLocale?: string,
  ) {
    super(platformLocation, baseHref);
    this.isPdAlias = !!isPdAlias;
    this.canonicalPrefix = '/' + (canonicalLocale || 'pl');
  }

  override path(includeHash?: boolean): string {
    const raw = super.path(includeHash);
    if (!this.isPdAlias) {
      return raw;
    }

    if (raw === this.canonicalPrefix || raw === this.canonicalPrefix + '/') {
      return '/';
    }

    if (raw.startsWith(this.canonicalPrefix + '/')) {
      return raw.substring(this.canonicalPrefix.length);
    }
    return raw;
  }

  override prepareExternalUrl(internal: string): string {
    if (!this.isPdAlias) {
      return super.prepareExternalUrl(internal);
    }

    const cleaned = internal.split('?')[0].split('#')[0];
    if (cleaned === '' || cleaned === '/') {
      return super.prepareExternalUrl(internal);
    }

    const normalized = internal.startsWith('/') ? internal : '/' + internal;
    return this.canonicalPrefix + normalized;
  }
}
